import { useTranslations } from "use-intl";

const STATUSES = ["unmatched", "matched", "rejected"] as const;
const PAYMENT_METHODS = ["card", "cash", "bank_transfer", "salary_adjustment"] as const;

function includes<T extends string>(list: readonly T[], value: string): value is T {
  return (list as readonly string[]).includes(value);
}

/** Words for a receipt's status and payment method; a value the catalog does not know shows as it is. */
export function useReceiptLabels() {
  const t = useTranslations("consultantBooks.receipts");
  return {
    status: (status: string) => (includes(STATUSES, status) ? t(`statuses.${status}`) : status),
    paymentMethod: (method: string) => (includes(PAYMENT_METHODS, method) ? t(`paymentMethods.${method}`) : method),
  };
}
